import React from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { LuLayoutGrid } from "react-icons/lu";
import { IoNotificationsOutline } from "react-icons/io5";
import { TiArrowBackOutline } from "react-icons/ti";

import { ProjectHeaderContainer } from "../styled/project";

const Header = ({
  clickSideMenu,
  setClickSideMenu,
  pageInfo = "프로젝트",
  navigatePath = "/mypage",
}) => {
  const navigate = useNavigate();
  const user = useSelector((state) => state?.user?.data[0]);
  const isDarkMode = useSelector((state) => state?.scheduler?.isDarkMode);
  const [, setCompanyInfo] = useState();

  return (
    <ProjectHeaderContainer id="schduler_header">
      <h1>모노티에 오신것을 환영합니다.</h1>
      <div className="float_wrap">
        <div className="float_left">
          <img
            className="schduler_header_img"
            src={isDarkMode ? "/img/logo.png" : "/img/logo.png"}
          />
          <span className="font_22 font600 font_color_white">{pageInfo}</span>
        </div>
        <div className="float_right">
          <button onClick={() => navigate(navigatePath)} style={{ fontSize: 37 }}>
            <TiArrowBackOutline />
          </button>
          <Link
            to="/mypage/notify"
            target="_blank"
            className="notify"
            onClick={() => user && localStorage.setItem("user", JSON.stringify(user))}>
            <IoNotificationsOutline />
          </Link>
          <div className="menuNav">
            <button className="navBtn" onClick={() => setClickSideMenu(!clickSideMenu)}>
              <LuLayoutGrid />
            </button>
          </div>
        </div>
      </div>
    </ProjectHeaderContainer>
  );
};

export default Header;
